<div *ngIf="!justButton" class="copy-text" [class.background-enable]="setBackground">
	<div class="copy-text-content font-M">{{ text }}</div>
	<div [cdkCopyToClipboard]="text" (click)="onCopy()" matRipple class="copy-icon"><img  src="assets/icons/copy.svg" height="17"></div>
</div>
<div *ngIf="justButton" [cdkCopyToClipboard]="text" (click)="onCopy()" class="flex-center c-p h-100 w-100"><img  src="assets/icons/copy.svg" height="17"></div>
